export default {
  GET_AUTOS(state, data) {
    state.autos = data.data
  },
  
  GET_ALL_AUTOS(state, data) {
    state.all_autos = data.data
  },
  
  GET_AUTO(state, data) {
    state.auto = data.data
  },
  
  AUTO_ERRORS(state, errors) {
    state.errors = errors
  }
}